










import Vue, { PropType } from "vue";
export default Vue.extend({
  props: {
    to: Object as PropType<object>,
    hasIcon: Boolean
  },
  methods: {
    onClick(evt: Event) {
      if (this.to) {
        this.$router.push(this.to);
      } else {
        this.$emit("click", evt);
      }
    }
  }
});
